import { getSecurityDexName } from '@src/utils/security';
import { SettleValueTypeEnum, Text, Tooltip, isSecurityQuantoFuture, type Security } from '@talos/kyoko';
import { useTheme } from 'styled-components';

interface PerpTitleProps {
  security: Security;
}
export const PerpTitle = ({ security }: PerpTitleProps) => {
  const isQuanto = isSecurityQuantoFuture(security);
  const isInverted = security.SettleValueType === SettleValueTypeEnum.Inverted;
  const theme = useTheme();

  const marginedCurrency = isQuanto
    ? security.SettlementCurrency
    : isInverted
      ? security.BaseCurrency
      : security.QuoteCurrency;

  const marginedTitle = isQuanto ? 'Quanto' : isInverted ? 'COIN-M' : `${security.QuoteCurrency}-M`;
  const dexName = getSecurityDexName(security.Metadata);
  const hasDexName = dexName != null && dexName !== '';
  const displayValue = hasDexName ? dexName : marginedTitle;

  return (
    <span>
      <Tooltip tooltip={`${marginedCurrency} margined Perp`}>
        <Text
          color={hasDexName ? theme.colors.green.lighten : theme.colors.gray['080']}
          textDecoration={hasDexName ? 'none' : 'underline'}
        >
          {displayValue}
        </Text>
      </Tooltip>
    </span>
  );
};
